<template>
	<div class="flex justify-end relative">
		<button @click="showFilterColumnModal = !showFilterColumnModal" class="btn btn-primary w-10">
			<app-icon icon="filters" class="px-3" />
		</button>
		<div
			v-if="showFilterColumnModal"
			class="absolute bg-white shadow-lg p-2 right-0 mt-2 w-72 overflow-auto z-50"
			style="top: 100%;"
		>
			<div class="flex flex-column items-end gap-1">
				<p class="hover:underline text-tiny" @click="selectAllColumns">Select all</p>
				<span>/</span>
				<p class="hover:underline text-tiny" @click="deselectAllColumns">Deselect all</p>
			</div>
			<app-input
				v-model="columnSearch"
				name="search"
				placeholder="Search"
				:icon="searching ? 'spin-loading' : 'search'"
				class="pt-2"
				:debounce-interval="300"
				@update:modelValue="onSearchInput"
			/>
			<div v-for="column in onSearchColumns.filter((col) => col.key !== 'selectAll')" :key="column.key">
				<div
					:class="column.key === 'codeId' ? 'hidden' : ''"
					class="flex flex-row items-center cursor-pointer"
					@click="selectField(column)"
				>
					<div class="flex w-4 h-4 border-1 border-gray-300 items-center justify-center mr-2">
						<input type="checkbox" :value="column.key" v-model="onChangeSelectedColumns" />
					</div>
					<span>{{ column.label }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import AppIcon from '@/components/app/AppIcon.vue';
	import AppInput from '@/components/app/AppInput.vue';

	export default {
		name: 'TableColumnsFilter',
		components: {
			AppIcon,
			AppInput,
		},
		emits: ['update:selectedColumns'],
		props: {
			columns: {
				type: Array,
				required: true,
			},
		},
		data() {
			return {
				showFilterColumnModal: false,
				columnSearch: '',
				searching: false,
				onChangeSelectedColumns: [],
				onSearchColumns: [],
			};
		},
		methods: {
			onSearchInput(value) {
				this.onSearchColumns = this.columns.filter((col) =>
					col.label.toLowerCase().includes(value.toLowerCase())
				);
			},
			selectField(column) {
				if (this.onChangeSelectedColumns.includes(column.key)) {
					this.onChangeSelectedColumns = this.onChangeSelectedColumns.filter((col) => col !== column.key);
				} else {
					this.onChangeSelectedColumns.push(column.key);
				}
				this.updateSelectedColumns();
			},
			selectAllColumns() {
				this.onChangeSelectedColumns = this.onSearchColumns.map((col) => col.key);
				this.updateSelectedColumns();
			},
			deselectAllColumns() {
				if (this.onChangeSelectedColumns.includes('selectAll')) {
					this.onChangeSelectedColumns = ['selectAll'];
				} else {
					this.onChangeSelectedColumns = [];
				}
				this.updateSelectedColumns();
			},
			updateSelectedColumns() {
				this.$emit('update:selectedColumns', this.onChangeSelectedColumns);
			},
		},
		mounted() {
			this.onSearchColumns = this.columns;
			this.onChangeSelectedColumns = this.columns
				.filter((column) => column.isSelected)
				.map((column) => column.key);
		},
		watch: {
			onChangeSelectedColumns() {
				this.updateSelectedColumns();
			},
		},
	};
</script>
